(() => {
  if (customElements.get('bb-signature-header')) return;
  const storageKey = 'broadbay-selected-school-v1';
  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const path = value => { try { return new URL(value, document.baseURI).pathname.replace(/\/$/, ''); } catch { return ''; } };
  const excluded = new Set(['illinois-illini', 'iowa-hawkeyes', 'iowa-state', 'missouri-tigers', 'southern-miss', 'northern-iowa-panthers']);
  const tagMap = {"alabama-crimson-tide": "Alabama", "arkansas-razorbacks": "Arkansas Razorbacks", "arizona-state": "Arizona State", "arizona-wildcats": "Arizona Wildcats", "auburn-tigers": "Auburn Tigers", "baylor-bears": "Baylor", "boise-state-broncos": "Boise State Broncos", "charlotte-49ers": "Charlotte 49ers", "clemson-tigers": "Clemson Tigers", "east-carolina": "ECU Pirates", "eastern-kentucky": "Eastern Kentucky", "florida-gators": "Florida Gators", "florida-state": "Florida State", "georgia-bulldogs": "Georgia Bulldogs", "george-mason": "george mason Patriots", "georgia-southern": "Georgia Southern", "georgia-tech": "Georgia Tech", "houston-cougars": "Houston Cougars", "illinois-illini": "Illinois", "indiana-university": "Indiana University", "iowa-hawkeyes": "Iowa Hawkeyes", "iowa-state": "Iowa State University", "james-madison": "JMU", "kansas-jayhawks": "Kansas Jayhawks", "kansas-state": "Kansas State", "kentucky-wildcats": "Kentucky Wildcats", "louisville-cardinals": "Louisville Cardinals", "lsu-tigers": "LSU Tigers", "marshall-university": "Marshall", "miami-university": "Miami University", "michigan-state-spartans": "Michigan State", "middle-tennessee": "Middle Tennessee", "mississippi-state": "Mississippi State", "missouri-state-bears": "Missouri State", "missouri-tigers": "Mizzou", "naval-academy-midshipmen": "Naval Academy", "nc-state": "NC State", "nebraska-huskers": "Nebraska Huskers", "northern-iowa-panthers": "Northern Iowa", "northwestern-wildcats": "Northwestern", "ohio-state-buckeyes": "Ohio State", "ohio-university-bobcats": "Ohio University", "oklahoma-state-cowboys": "Oklahoma State", "old-dominion-monarchs": "ODU", "ole-miss": "Ole Miss", "oregon-state-beavers": "Oregon State", "purdue-university": "Purdue", "rutgers-university": "Rutgers", "south-carolina-gamecocks": "University of South Carolina", "southern-miss": "Southern Miss", "tcu-horned-frogs": "TCU", "tennessee-vols": "Tennessee", "texas-a-m": "TAMU", "texas-tech": "Texas Tech Red Raiders", "utep-miners": "UTEP", "virginia-cavaliers": "Virginia Cavaliers", "virginia-tech": "Virginia Tech", "washington-state-cougars": "Washington State", "west-virginia-mountaineers": "West Virginia", "ucf": "UCF"};
  class SignatureHeader extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schoolMenu = this.querySelector('.bbh-school-menu');
      this.disclosures = [...this.querySelectorAll('[data-bb-nav-details]')];
      this.context = JSON.parse(this.querySelector('[data-bbh-context-data]').textContent);
      this.schools = [...this.schoolMenu.querySelectorAll('[data-bb-team] a')].map(link => {
        const url = path(link.href);
        const handle = url.split('/').pop();
        return { url, handle, name: link.querySelector('.bb-school-name').textContent.trim(), logo: link.querySelector('img')?.getAttribute('src') || '', tag: tagMap[handle] || '', link };
      });
      this.querySelectorAll('[data-bbh-choose]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.openSchools();
      }, { signal }));
      this.querySelector('[data-bbh-cart]').addEventListener('click', event => {
        const drawer = document.querySelector('#mini-cart');
        if (typeof drawer?.open !== 'function') return;
        event.preventDefault();
        this.disclosures.forEach(menu => { menu.open = false; });
        this.querySelector('bb-site-search')?.close();
        drawer.open();
      }, { signal });
      const drawer = document.querySelector('#mini-cart');
      if (drawer) {
        const syncDrawer = () => {
          const isOpen = drawer.classList.contains('open');
          if (!isOpen && drawer.contains(document.activeElement)) this.querySelector('[data-bbh-cart]').focus({ preventScroll: true });
          drawer.setAttribute('aria-hidden', String(!isOpen));
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-label', this.querySelector('[data-bbh-cart]').getAttribute('aria-label'));
          drawer.setAttribute('aria-modal', String(isOpen));
          drawer.querySelector('.mini-cart__sidebar')?.setAttribute('aria-hidden', String(!isOpen));
          drawer.inert = !isOpen;
          if (isOpen && !drawer.contains(document.activeElement)) drawer.querySelector('#cart-close')?.focus({ preventScroll: true });
        };
        this.drawerObserver = new MutationObserver(syncDrawer);
        this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        syncDrawer();
      }
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        const school = this.schools.find(item => item.url === path(link.href));
        if (school) this.selectSchool(school);
      }, { signal });
      document.addEventListener('focusin', event => {
        this.disclosures.forEach(menu => {
          if (menu.open && !menu.contains(event.target) && !event.target.closest('[data-bbh-choose]')) menu.open = false;
        });
      }, { signal });
      this.disclosures.forEach(menu => menu.addEventListener('toggle', () => {
        menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
      }, { signal }));
      window.addEventListener('pageshow', () => this.restoreSchool(), { signal });
      this.restoreSchool();
    }
    disconnectedCallback() { this.abort?.abort(); this.drawerObserver?.disconnect(); this.abort = null; }
    openSchools() {
      this.disclosures.forEach(menu => { menu.open = menu === this.schoolMenu; });
      this.querySelector('bb-site-search')?.close();
      const input = this.schoolMenu.querySelector('[data-bb-team-search]');
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus({ preventScroll: true });
      if (this.getBoundingClientRect().bottom < 0) this.scrollIntoView({ block: 'start' });
    }
    restoreSchool() {
      const context = this.context;
      let selected = this.schools.find(school => school.url === path(location.pathname));
      if (!selected && context.pageType === 'product') {
        const collections = (context.productCollections || []).map(path);
        const matches = this.schools.filter(school => collections.includes(school.url));
        if (matches.length === 1) selected = matches[0];
        if (!selected) {
          const tags = (context.productTags || []).map(normalize);
          const tagMatches = this.schools.filter(school => school.tag && tags.includes(normalize(school.tag)));
          if (tagMatches.length === 1) selected = tagMatches[0];
        }
      }
      if (!selected && context.currentTags?.length === 1) {
        selected = this.schools.find(school => school.tag && normalize(school.tag) === normalize(context.currentTags[0]));
      }
      if (!selected && context.pageType === 'product') {
        const title = ` ${normalize(context.productTitle)} `;
        const matches = this.schools.filter(school => school.tag && title.includes(` ${normalize(school.tag)} `)).sort((a, b) => b.tag.length - a.tag.length);
        if (matches.length === 1 || (matches.length > 1 && matches[0].tag.length > matches[1].tag.length)) selected = matches[0];
      }
      if (!selected) {
        try { const saved = localStorage.getItem(storageKey); selected = this.schools.find(school => school.url === saved); } catch {}
      }
      if (selected) this.selectSchool(selected);
    }
    selectSchool(school) {
      try { localStorage.setItem(storageKey, school.url); } catch {}
      this.querySelector('[data-bbh-school-label]').textContent = school.name;
      const link = this.querySelector('[data-bbh-current]');
      link.href = school.url;
      this.querySelector('[data-bbh-current-name]').textContent = school.name;
      const logo = this.querySelector('[data-bbh-current-logo]');
      logo.hidden = !school.logo;
      if (school.logo) logo.src = school.logo;
      const categories = this.querySelector('[data-bbh-categories]');
      const fragment = document.createDocumentFragment();
      const addLink = (url, title) => {
        const item = document.createElement('a');
        item.href = url;
        item.textContent = title;
        if (path(location.pathname) === path(url)) item.setAttribute('aria-current', 'page');
        fragment.append(item);
      };
      addLink(school.url, this.context.allLabel);
      if (school.tag && !excluded.has(school.handle)) {
        this.context.categories.forEach(category => {
          const tag = (category.tags || []).find(item => normalize(item) === normalize(school.tag));
          if (!category.url || !tag) return;
          const handle = normalize(tag).replace(/ /g, '-');
          addLink(`${category.url}/${handle}`, category.title);
        });
      }
      categories.replaceChildren(fragment);
      this.querySelector('[data-bbh-context]').hidden = false;
      this.schools.forEach(item => item.link.toggleAttribute('data-selected', item === school));
    }
  }
  customElements.define('bb-signature-header', SignatureHeader);
})();
